import React, { useState } from 'react';
import StartListsView from './StartListsView';
import StartListDetails from './StartListDetails';
import StartListEditor from './Demo_StartListEditor';

const StartListsDemo = () => {
  const [activeDemo, setActiveDemo] = useState('view');

  return (
    <div>
      {/* Simple demo switcher */}
      <div
        style={{ padding: '20px', background: '#f0f0f0', marginBottom: '20px' }}
      >
        <h2>Start Lists Prototypes</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => setActiveDemo('view')}>Event List View</button>
          <button onClick={() => setActiveDemo('details')}>Details View</button>
          <button onClick={() => setActiveDemo('editor')}>Editor View</button>
        </div>
      </div>

      {/* Show selected demo */}
      {activeDemo === 'view' && <StartListsView />}
      {activeDemo === 'details' && <StartListDetails />}
      {activeDemo === 'editor' && <StartListEditor />}
    </div>
  );
};

export default StartListsDemo;
